import { useEffect, useState } from 'react';
import { ConfirmationModal } from './ConfirmationModal';
import { confirmationService } from '../services/confirmationService';

/**
 * Container component that manages confirmation modals
 * Listens for confirmation requests and displays the modal
 */
export const ConfirmationContainer = () => {
    const [confirmation, setConfirmation] = useState<{
        id: string;
        message: string;
        confirmText?: string;
        cancelText?: string;
        isDestructive?: boolean;
    } | null>(null);

    useEffect(() => {
        const handleRequest = () => {
            const pending = confirmationService.getNextConfirmation();
            if (pending) {
                setConfirmation({
                    id: pending.id,
                    message: pending.props.message,
                    confirmText: pending.props.confirmText,
                    cancelText: pending.props.cancelText,
                    isDestructive: pending.props.isDestructive
                });
            }
        };

        const handleResolved = () => {
            setConfirmation(null);
            // Check if there's another pending confirmation
            setTimeout(() => {
                const pending = confirmationService.getNextConfirmation();
                if (pending) {
                    setConfirmation({
                        id: pending.id,
                        message: pending.props.message,
                        confirmText: pending.props.confirmText,
                        cancelText: pending.props.cancelText,
                        isDestructive: pending.props.isDestructive
                    });
                }
            }, 100);
        };

        window.addEventListener('app-confirmation-request', handleRequest);
        window.addEventListener('app-confirmation-resolved', handleResolved);

        // Check for any pending confirmations on mount
        handleRequest();

        return () => {
            window.removeEventListener('app-confirmation-request', handleRequest);
            window.removeEventListener('app-confirmation-resolved', handleResolved);
        };
    }, []);

    if (!confirmation) {
        return null;
    }

    const handleConfirm = () => {
        confirmationService.resolveConfirmation(confirmation.id, true);
    };

    const handleCancel = () => {
        confirmationService.resolveConfirmation(confirmation.id, false);
    };

    return (
        <ConfirmationModal
            message={confirmation.message}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            confirmText={confirmation.confirmText}
            cancelText={confirmation.cancelText}
            isDestructive={confirmation.isDestructive}
        />
    );
};

